import React, {
    useEffect,
    useMemo,
    useState,
} from "react";

import axiosConfig from "../../AxiosConfig";

export default function CompeleteStockReport() {
    const [hideZeroQty, setHideZeroQty] =
        useState(false);
        const [category, setCategory] = useState("All");
    const [data, setData] = useState([]);
    const [summary, setSummary] =
        useState({});
    const [loading, setLoading] =
        useState(false);

    const [search, setSearch] =
        useState("");

    const fetchReport = async () => {
        try {
            setLoading(true);

            const userData = JSON.parse(
                localStorage.getItem("userData")
            );

            const database =
                userData?.database;

            const currentDate =
                new Date();

            const currentYear =
                currentDate.getFullYear();

            const nextYear =
                currentYear + 1;

            const month =
                currentDate.getMonth() + 1;

            const financialYear =
                month >= 4
                    ? `${currentYear}-${nextYear}`
                    : `${currentYear - 1}-${currentYear}`;

            const res =
                await axiosConfig.get(
                    `/stock-updation/view-stock-report/${database}/${financialYear}`
                );
            console.log(
                "COMPLETE STOCK REPORT",
                res?.data
            );
            setData(
                res?.data?.data || []
            );

            setSummary(
                res?.data?.totalSummary || {}
            );
        } catch (err) {
            console.log(err);

            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport();
    }, []);

    // const filteredData = useMemo(() => {
    //     return data.filter((item) => {

    //         const matchesSearch =
    //             item?.Product_Title
    //                 ?.toLowerCase()
    //                 ?.includes(
    //                     search.toLowerCase()
    //                 );

    //         if (!hideZeroQty) {
    //             return matchesSearch;
    //         }

    //         return (
    //             matchesSearch &&
    //             Number(item?.closingQty || 0) > 0
    //         );

    //     });
    // }, [
    //     data,
    //     search,
    //     hideZeroQty,
    // ]);
const filteredData = useMemo(() => {
  return data.filter((item) => {
    const matchesSearch =
      item?.Product_Title
        ?.toLowerCase()
        ?.includes(search.toLowerCase());

    const matchesCategory =
      category === "All" ||
      item?.category?.toLowerCase() === category.toLowerCase();

    if (!hideZeroQty) {
      return matchesSearch && matchesCategory;
    }

    return (
      matchesSearch &&
      matchesCategory &&
      Number(item?.closingQty || 0) > 0
    );
  });
}, [data, search, hideZeroQty, category]);
    const formatNumber = (
        value,
        digits = 2
    ) => {
        const num = Number(value);

        if (isNaN(num)) return value || 0;

        return num.toFixed(digits);
    };

    return (
        <div
            className="erp-page-grid"
            style={{
                padding: "10px",
            }}
        >
            {/* Header */}

           <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  }}
>
  {/* Left Side */}
  <h3
    style={{
      margin: 0,
    }}
  >
    COMPLETE STOCK REPORT
  </h3>

  {/* Right Side */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
    }}
  >
    <select
  className="form-control"
  style={{ width: "180px" }}
  value={category}
  onChange={(e) => setCategory(e.target.value)}
>
  <option value="All">All Category</option>
  <option value="sales">Sales</option>
  <option value="production">Production</option>
</select>
    <input
      type="text"
      placeholder="Search Item..."
      value={search}
      onChange={(e) =>
        setSearch(e.target.value)
      }
      style={{
        width: "250px",
        padding: "8px",
      }}
    />

    <button
      className={`btn ${
        hideZeroQty
          ? "btn-danger"
          : "btn-primary"
      }`}
      onClick={() =>
        setHideZeroQty(!hideZeroQty)
      }
    >
      {hideZeroQty
        ? "Show 0 Qty"
        : "Hide 0 Qty"}
    </button>
  </div>
</div>

            <div
                style={{
                    overflowX: "auto",
                }}
            >
                <table
                    className="table table-bordered"
                    style={{
                        minWidth: "1800px",
                        textAlign: "center",
                    }}
                >
                    <thead>
                        <tr>
                            <th
                                colSpan="2"
                                style={{
                                    background:
                                        "#d9a066",
                                }}
                            >
                                PRODUCT DETAILS
                            </th>

                            <th
                                colSpan="3"
                                style={{
                                    background:
                                        "green",
                                    color: "#fff",
                                }}
                            >
                                OPENING STOCK DETAILS
                            </th>

                            <th
                                colSpan="3"
                                style={{
                                    background:
                                        "green",
                                    color: "#fff",
                                }}
                            >
                                INWARD STOCK DETAILS
                            </th>

                            <th
                                colSpan="3"
                                style={{
                                    background:
                                        "red",
                                    color: "#fff",
                                }}
                            >
                                OUTWARD STOCK DETAILS
                            </th>

                            <th
                                colSpan="3"
                                style={{
                                    background:
                                        "green",
                                    color: "#fff",
                                }}
                            >
                                CLOSING STOCK DETAILS
                            </th>
                        </tr>

                        <tr>
                            <th>PRODUCT NAME</th>
                            <th>HSN</th>

                            <th>OPENING QTY</th>
                            <th>Opening RATE</th>
                            <th>TOTAL</th>

                            <th>INWARD QTY</th>
                            <th>PURCHASE RATE</th>
                            <th>TOTAL</th>

                            <th>SALE QTY</th>
                            <th>SALE RATE</th>
                            <th>TOTAL</th>

                            <th>CLOSING STOCK</th>
                            <th>AVG PRICE</th>
                            <th>TOTAL</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan="14"
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : filteredData.length ===
                            0 ? (
                            <tr>
                                <td
                                    colSpan="14"
                                >
                                    No Data Found
                                </td>
                            </tr>
                        ) : (
                            <>
                                {filteredData.map(
                                    (
                                        item,
                                        index
                                    ) => (
                                        <tr
                                            key={index}
                                        >
                                            <td>
                                                {
                                                    item.Product_Title
                                                }
                                            </td>

                                            <td>
                                                {item.HSN_Code ||
                                                    item.HSN_Code ||
                                                    "-"}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.oQty
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.openingRate
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.openingTotal
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.iQty
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.inwardRate
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.inwardTotal
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.outwardQty
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.saleRate
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.outwardTotal
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.closingQty
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.closingRate
                                                )}
                                            </td>

                                            <td>
                                                {formatNumber(
                                                    item.closingTotal
                                                )}
                                            </td>
                                        </tr>
                                    )
                                )}

                                <tr
                                    style={{
                                        fontWeight:
                                            "bold",
                                        background:
                                            "#f2f2f2",
                                    }}
                                >
                                    <td>TOTAL</td>
                                    <td></td>

                                    <td>
                                        {formatNumber(
                                            summary.oQty
                                        )}
                                    </td>

                                    <td></td>

                                    <td>
                                        {formatNumber(
                                            summary.openingTotal
                                        )}
                                    </td>

                                    <td>
                                        {formatNumber(
                                            summary.iQty
                                        )}
                                    </td>

                                    <td></td>

                                    <td>
                                        {formatNumber(
                                            summary.inwardTotal
                                        )}
                                    </td>

                                    <td>
                                        {formatNumber(
                                            summary.outwardQty
                                        )}
                                    </td>

                                    <td></td>

                                    <td>
                                        {formatNumber(
                                            summary.outwardTotal
                                        )}
                                    </td>

                                    <td>
                                        {formatNumber(
                                            summary.closingQty
                                        )}
                                    </td>

                                    <td></td>

                                    <td>
                                        {formatNumber(
                                            summary.closingTotal
                                        )}
                                    </td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}